// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-snakerflow-designer[data-v-3efb7f06]{width:100%;height:100%;position:relative}", ""]);
// Exports
module.exports = exports;
